<p-card class="p-card container">
  <h3 i18n>Informations du client</h3>

  <form [formGroup]="form">
    <div class="layout__inner-card">
      <div class="layout--gap mb-4">
        <div class="layout--full-width">
          <label class="label-top" i18n>Prénom</label>
          <input [formControl]="form.controls.firstName" pInputText />
        </div>

        <div class="layout--full-width">
          <label class="label-top" i18n>Deuxième prénom</label>
          <input pInputText [formControl]="form.controls.middleName" placeholder="--" />
        </div>

        <div class="layout--full-width">
          <label class="label-top" i18n>Nom de famille</label>
          <input [formControl]="form.controls.lastName" pInputText />
        </div>
      </div>

      <div class="layout--gap mb-4">
        <div class="layout--full-width">
          <label class="label-top" i18n>Date de naissance</label>
          <div class="layout--row layout--gap">
            <input [formControl]="form.controls.birthday" pInputText />
            <em-text-indicator
              [text]="age.toString()"
              [withTooltip]="true"
              i18n-tooltipText
              tooltipText="Âge du client au moment de l'achat."></em-text-indicator>
          </div>
        </div>

        <div class="layout--full-width">
          <label class="label-top" i18n>Sexe</label>
          <p-dropdown
            [options]="sexOptions | emTranslate"
            [formControl]="form.controls.sex"
            optionLabel="name"
            optionValue="value"></p-dropdown>
        </div>

        <div class="layout--full-width">
          <label class="label-top" i18n>Pays de naissance</label>
          <p-dropdown
            [options]="countriesOptions | emTranslate"
            [formControl]="form.controls.birthCountry"
            optionLabel="name"
            optionValue="value"></p-dropdown>
        </div>
      </div>

      <div class="layout--gap">
        <div class="layout--full-width">
          <label class="label-top" i18n>Salaire</label>
          <input
            [formControl]="form.controls.salary"
            [thousandSeparator]="isFr ? ' ' : ','"
            [prefix]="!isFr ? '$' : ''"
            [suffix]="isFr ? ' $' : ''"
            mask="separator.0"
            placeholder="--"
            id="salary"
            pInputText />
        </div>

        @switch (form.controls.birthCountry.value) {
          @case (country.CA) {
            <div class="layout--full-width">
              <label class="label-top" i18n>Province de naissance</label>
              <p-dropdown
                [options]="provinceOptions | emTranslate"
                [formControl]="form.controls.birthState"
                optionLabel="name"
                optionValue="value"></p-dropdown>
            </div>
          }
          @case (country.US) {
            <div class="layout--full-width">
              <label class="label-top" i18n>État de naissance</label>
              <p-dropdown
                [options]="stateOptions | emTranslate"
                [formControl]="form.controls.birthState"
                optionLabel="name"
                optionValue="value"></p-dropdown>
            </div>
          }
          @default {
            <div class="layout--full-width"></div>
          }
        }
      </div>
    </div>

    <h3 i18n>Communication</h3>

    <div class="layout__inner-card">
      <div class="layout--gap mb-4">
        <div class="layout--full-width">
          <label class="label-top" i18n>Langue</label>
          <p-dropdown
            [options]="languageOptions | emTranslate"
            [formControl]="form.controls.preferredLanguage"
            optionLabel="name"
            optionValue="value"></p-dropdown>
        </div>

        <div class="layout--full-width">
          <label class="label-top" i18n>Adresse courriel</label>
          <input [formControl]="form.controls.email" pInputText />
        </div>

        <div class="layout--full-width">
          <label class="label-top" i18n>Numéro de téléphone</label>
          <input [formControl]="form.controls.phone" mask="(000) 000-0000" pInputText />
        </div>
      </div>
    </div>

    <h3 i18n>Adresse de résidence principale</h3>

    <div class="layout__inner-card">
      <div class="layout--gap mb-4">
        <div class="layout--full-width">
          <label class="label-top" i18n>Adresse de résidence</label>
          <input [formControl]="form.controls.address" pInputText />
        </div>

        <div class="layout--full-width">
          <label class="label-top" i18n>Numéro d'appartement (optionnel)</label>
          <input [formControl]="form.controls.unitNumber" pInputText />
        </div>
      </div>

      <div class="layout--gap">
        <div class="layout--full-width">
          <label class="label-top" i18n>Ville</label>
          <input [formControl]="form.controls.city" pInputText />
        </div>

        <div class="layout--full-width">
          <label class="label-top" i18n>Province</label>
          <p-dropdown
            [options]="currentProvinceOptions | emTranslate"
            [formControl]="form.controls.province"
            optionLabel="name"
            optionValue="value"></p-dropdown>
        </div>

        <div class="layout--full-width">
          <label class="label-top" i18n>Code postal</label>
          <input [formControl]="form.controls.postalCode" mask="S0S 0S0" pInputText />
        </div>
      </div>
    </div>

    @if (isPolicyReplacementDownloadEnabled) {
      <h3 i18n>Remplacement de police</h3>
      
      @if (hasPolicyReplacementNotice) {
        <p-button
          (onClick)="downloadPolicyReplacementDocument()"
          [loading]="isDownloadingReplacementNotice"
          i18n-label
          label="Télécharger le document"
          icon="pi pi-download"></p-button>
      } @else {
        <p i18n class="font-italic">Aucun remplacement de police</p>
      }
    }
  </form>
</p-card>
